let mountedCount = 0;

export const billingDataViewMounted = () => {
	mountedCount++;
};

export const billingDataViewUnmounted = () => {
	mountedCount--;
};

export const isBillingDataViewMounted = () => mountedCount > 0;
